const styles = (theme) => ({
  ...theme.global,
  box: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.background.paper
  }
})
export default styles
